import React, { Component } from 'react';
import {baseUrl} from '../../url';
import moment from 'moment';

class LFT extends Component{
    state = {
        type: 'lft',
        ast: '',
        alt: '',
        alk_phosphate: '',
        ggt: '',
        total_protein: '',
        albumin: '',
        bilirubin_direct: '',
        bilirubin_total: '',
        date: '',
        success: false,
        response: true,
    }
    handleChange = (e) =>{
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });
        if(e.target.name === 'date'){
            let date  = moment(e.target.value).format('YYYY-MM-DD HH:mm:ss')
            this.setState({
                date
            })
        }
    }
    close = () => {
        setTimeout(() => { 
            this.props.handleClose();
        }, 1000);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const {type, date , ast, alt , alk_phosphate, ggt, total_protein, albumin, bilirubin_direct, bilirubin_total} = this.state;

        if(!date){
            this.setState({
                dateError: 'Please enter a valid date'
            })
        }
        if(!ast){
            this.setState({
                astError: 'This field cannot be empty'
            })
        }
        if(!alt){
            this.setState({
                altError: 'This field cannot be empty'
            })
        }
        if(!alk_phosphate){
            this.setState({
                alk_phosphateError: 'This field cannot be empty'
            })
        }
        if(!ggt){
            this.setState({
                ggtError: 'This field cannot be empty'
            })
        }
        if(!total_protein){
            this.setState({
                total_proteinError: 'This field cannot be empty'
            })
        }
        if(!albumin){
            this.setState({
                albuminError: 'This field cannot be empty'
            })
        }
        if(!bilirubin_direct){
            this.setState({
                bilirubin_directError: 'This field cannot be empty'
            })
        }
        if(!bilirubin_total){
            this.setState({
                bilirubin_totalError: 'This field cannot be empty'
            })
        }
        if( type && date && ast && alt && alk_phosphate && ggt && total_protein && albumin && bilirubin_direct && bilirubin_total){
            this.setState({
                response: false
            })
            const token = localStorage.getItem('access_token');
            const id = localStorage.getItem('user_id');
            let retries = 0;
            let entry = {
                'treatment_date': date,
                type,
                ast,
                alt,
                alk_phosphate,
                ggt,
                total_protein,
                albumin,
                bilirubin_direct,
                bilirubin_total
            };

            fetch(`${baseUrl}/admin/patients/tests/${id}`,{
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(entry)
            })
            .then(response => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then(responseJson => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                   if(responseJson._meta._status === 202){
                       this.setState({
                           success: true,
                           message: responseJson.message
                       }, () => {
                           this.props.hideField();
                           this.props.refresh();
                           this.close();
                       })
                   }
                }
            })
            .catch((error) => {
                if (error === 401 && retries < 1) {
                    localStorage.getItem('access_token')
                        .then(value => {
                            fetch(`${baseUrl}/token/refresh`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': value
                                }
                            }).then(response => {
                                retries += 1;
                                if (response.status === 200) {
                                    localStorage.setItem('access_token', response.headers.get('Authorization'));
                                    this.handleSubmit();
                                }
                                else {
                                    alert('something went wrong please try again later');
                                }
                            })
                        })
                }
                else {
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){
        const {success} = this.state;
        return(
            <React.Fragment>
                {
                    !success &&
                    <React.Fragment>
                        <label>
                            Date test was taken
                            <input type="date" onChange={this.handleChange} name="date" className={this.state.dateError ? 'error-input' : ''} />
                            <span className="error-text">{this.state.dateError}</span>
                        </label>
                        <label>
                            AST
                            <input type="number" onChange={this.handleChange} name="ast" className={this.state.astError ? 'error-input' : ''} />
                            <span>IU/L</span>
                            <span className="regular">Normal Range 10-50</span>
                            <span className="error-text">{this.state.astError}</span>
                        </label>
                        <label>
                            ALT
                            <input type="number" onChange={this.handleChange} name="alt" className={this.state.altError ? 'error-input' : ''} />
                            <span>IU/L</span>
                            <span className="regular">Normal Range 10-50</span>
                            <span className="error-text">{this.state.altError}</span>
                        </label>
                        <label>
                            Alkaline Phosphate
                            <input type="number" step="0.1" onChange={this.handleChange} name="alk_phosphate" className={this.state.alk_phosphateError ? 'error-input' : ''} />
                            <span>IU/L</span>
                            <span className="regular">Ad 21.3-106.3, Ch 21.3-213</span>
                            <span className="error-text">{this.state.alk_phosphateError}</span>
                        </label>
                        <label>
                            GGT
                            <input type="number" onChange={this.handleChange} name="ggt" className={this.state.ggtError ? 'error-input' : ''} />
                            <span>IU/L</span>
                            <span className="regular">Normal Range 7-50</span>
                            <span className="error-text">{this.state.ggtError}</span>
                        </label>
                        <label>
                            Total Protein
                            <input type="number" onChange={this.handleChange} name="total_protein" className={this.state.total_proteinError ? 'error-input' : ''} />
                            <span>g/L</span>
                            <span className="regular">Normal Range 66-87</span>
                            <span className="error-text">{this.state.total_proteinError}</span>
                        </label>
                        <label>
                            Albumin
                            <input type="number" onChange={this.handleChange} name="albumin" className={this.state.albuminError ? 'error-input' : ''} />
                            <span>g/L</span>
                            <span className="regular">Normal Range 35-52</span>
                            <span className="error-text">{this.state.albuminError}</span>
                        </label>
                        <label>
                            Bilirubin (Direct)
                            <input type="number" onChange={this.handleChange} name="bilirubin_direct" className={this.state.bilirubin_directError ? 'error-input' : ''} />
                            <span>Umol/L</span>
                            <span className="regular">Normal Range 2-18</span>
                            <span className="error-text">{this.state.bilirubin_directError}</span>
                        </label>
                        <label>
                            Bilirubin (Total)
                            <input type="number" onChange={this.handleChange} name="bilirubin_total" className={this.state.bilirubin_totalError ? 'error-input' : ''} />
                            <span>Umol/L</span>
                            <span className="regular">Normal Range 3-25</span>
                            <span className="error-text">{this.state.bilirubin_totalError}</span>
                        </label>
                        <button onClick={this.handleSubmit}>
                            Save
                            {
                                !this.state.response &&
                                <i className="fa fa-spinner fa-pulse fa-fw" />
                            }
                        </button>
                    </React.Fragment>
                }
                {
                    this.state.success &&
                    <div className="check">
                        <div className="svg-div">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                            </svg>
                        </div>
                        <p><small>{this.state.message}</small></p>
                    </div> 
                }
            </React.Fragment>
        )
    }
}

export default LFT;


// WEBPACK FOOTER //
// ./src/components/patientProfile/testForms/lft.js